<template>
    <div class="col-sm-12 col-w">
        <br/>
        <br/>
        <div class="card">
            <div class="card-header card-header-v2" style="padding-bottom: 0">
                <h4 class="title-relatorio">Aeração</h4>
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <button :class="['nav-link', 'button-component', { active: tabStatus }]" data-toggle="tab" @click="activateTabStatus(true)" style="border-radius: 10px 10px 0px 0px !important;">Status</button>
                    </li>
                    <li class="nav-item">
                        <button :class="['nav-link', 'button-component', { active: tabHistorico }]" data-toggle="tab" @click="activatetabHistorico(true)" style="border-radius: 10px 10px 0px 0px !important;">Histórico semanal da aeração</button>
                    </li>
                </ul>
            </div>
            <div class="card-body card-body-v2">
                <div class="tab-content">
                    <div id="statusMotoresTab" class="container container-programa tab-pane" :class="{ active: tabStatus }">
                        <ul class="list-group list-group-horizontal no-border list-w" v-if="aeracao && aeracao.aeracao">
                            <li class="list-group-item no-border">
                                <span>Status: &nbsp;</span>
                                <span :style="{ color: statusColor }" class="text-bolder">{{ statusMotor }}</span>
                            </li>
                            <li class="list-group-item no-border"> 
                                <span>Programa: &nbsp;</span>
                                <span class="text-bolder">{{ descricaoPrograma }}</span>
                            </li>
                            <li v-if="this.programa.numero != 8" class="list-group-item no-border">
                                <span>Parâmetros: &nbsp;</span>
                                <span>{{ descricaoParametros }}</span>
                            </li>
                            <li class="list-group-item no-border">
                                <span>Total horas aeradas: &nbsp;</span>
                                <span>{{ horasAeradasFormatadas }} | {{ dataInicio }}</span>
                            </li>
                        </ul>
                        <div class="row">
                            <MotorList v-if="aeracao && aeracao.motores && aeracao.aeracao && aeracao.aeracao.data"
                                :motores="aeracao.motores" 
                                :aeracao-data="aeracao.aeracao.data" 
                                :modoOperacao="modoOperacao"
                            />
                        </div>
                    </div>
                    <div id="detalhesTab" class="container container-programa tab-pane" style="max-width: 685px;max-height: 420px;" :class="{ active: tabHistorico }">
                        <canvas id="aeracaoChart" style="max-height: 50vh"></canvas>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import MotorList from './MotorList.vue';
import { Chart } from 'chart.js';

export default {
    components: {
        MotorList
    },
    props: {
        aeracao: {
            type: Object
        },
        modoOperacao: {
            type: Number
        },
        programa: {
            type: Number
        }
    },
    data() {
        return {
            tabStatus: true,
            tabHistorico: false,
            chart: null,
        }
    },
    methods: {
        activateTabStatus (action) {
            this.tabStatus = action;
            this.tabHistorico = false;
        },
        activatetabHistorico (action) {
            this.tabHistorico = action;
            this.tabStatus = false;
            this.renderChart();
        },

        renderChart() {
            if (this.aeracao && this.aeracao.aeracao && this.aeracao.horas_aeradas && this.aeracao.horas_aeradas.horas_week) {
                const dados = this.aeracao.horas_aeradas.horas_week;
                const labels = this.getLast7Days();
                const hours = labels.map(date => {
                    const buscaDados = dados.find(item => item.date === date);
                    const totalHoras = buscaDados ? buscaDados.total_horas / 3600 : 0;
                    return totalHoras;
                });

                if (this.chart) {
                    this.chart.destroy();
                }

                const ctx = document.getElementById('aeracaoChart').getContext('2d');
                this.chart = new Chart(ctx, {
                    type: 'bar',
                    data: {
                        labels: labels,
                        datasets: [{
                            label: 'Total de Horas',
                            data: hours,
                            backgroundColor: '#4783F3',
                            fill: true,
                            size: 10
                        }]
                    },
                    options: {
                        plugins: {
                            title: {
                                display: true,
                                text: 'Histórico de Aeração',
                                font: {
                                    size: 14
                                }
                            },
                            subtitle: {
                                display: true,
                                text: 'Últimos 7 dias: Tempo Aerado',
                                font: {
                                    size: 12
                                }
                            },
                        },
                        scales: {
                            x: {
                                title: {
                                    display: true,
                                    text: 'Data'
                                },
                                reverse: true
                            },
                            y: {
                                title: {
                                    display: true,
                                    text: 'Total de Horas'
                                },
                                beginAtZero: true
                            }
                        },
                        responsive: true,
                        maintainAspectRatio: false
                    }
                });
            }
        },



        getLast7Days() {
            const today = new Date();
            const dates = [];
            for (let i = 6; i >= 0; i--) {
                const date = new Date(today);
                date.setDate(today.getDate() - i);
                dates.push(this.formatDate(date));
            }
            return dates;
        },

        formatDate(date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        formatarDataPTBR(dataISO) {
            const data = new Date(dataISO);
            
            const dia = String(data.getDate()).padStart(2, '0');
            const mes = String(data.getMonth() + 1).padStart(2, '0'); 
            const ano = data.getFullYear();

            const horas = String(data.getHours()).padStart(2, '0');
            const minutos = String(data.getMinutes()).padStart(2, '0');
            const segundos = String(data.getSeconds()).padStart(2, '0');

            return `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`;
        }
    },
    computed: {
        statusMotor() {
            if (this.aeracao && this.aeracao.aeracao) {
                if (this.aeracao.aeracao.modo_operacao == 0) {
                    return "Aeração no manual";
                } else if (this.aeracao.aeracao.bloqueio_aeracao == 1) {
                    return "Aeração bloqueada";
                } else {
                    return "Aeração automática";
                }
            }
            return "";
        },
        statusColor() {
            switch (this.statusMotor) {
                case "Aeração no manual":
                    return "#ff9800";
                case "Aeração bloqueada":
                    return "#ff9800";
                case "Aeração automática":
                    return "#33b35a";
                default:
                    return "#000";
            }
        },
        descricaoParametros() {
            if (this.aeracao && this.aeracao.aeracao && this.aeracao.aeracao.parametros) {
                const { temperatura_maxima, temperatura_minima, umidade_maxima, umidade_minima, horario_inicio, horario_final, media } = this.aeracao.aeracao.parametros;
                
                switch (this.programa.numero) {
                    case 1:
                        return ` Temperatura Máxima: ${temperatura_maxima} °C - Temperatura Mínima: ${temperatura_minima}°C | Umidade Máxima: ${umidade_maxima}% - Umidade Mínima: ${umidade_minima}%`       
                    case 2:
                        return ` Temperatura Máxima: ${temperatura_maxima} °C - Temperatura Mínima: ${temperatura_minima}°C | Umidade Máxima: ${umidade_maxima}% - Umidade Mínima: ${umidade_minima}% | Horário de Início: ${horario_inicio} - Horário Final: ${horario_final}`       
                    case 3:
                        return ` Umidade Máxima: ${umidade_maxima}% | Umidade Mínima: ${umidade_minima}%`       
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                            return `Média: ${media} °C`;
                    default:
                        return ""
                }
            }
            return "";
        },
        descricaoPrograma() {
            if (this.aeracao && this.aeracao.aeracao) {
                switch (this.programa.numero) {
                    case 1:
                        return "Programa Livre"        
                    case 2:
                        return "Programa Livre Temporizado"
                    case 3:
                        return "Programa Equilibrio Higroscopico"
                    case 4:
                        return "Programa Curva 1"    
                    case 5:
                        return "Programa Curva 2"   
                    case 6:
                        return "Programa Curva 3"   
                    case 7:
                        return "Programa Curva 4"       
                    case 8:
                        return "Programa Personalizado"       
                    default:
                        return ""
                }
            }
            return ""
        },
        horasAeradasFormatadas() {
            if (this.aeracao && this.aeracao.horas_aeradas && this.aeracao.horas_aeradas.horas_all) {
                const totalSegundos = this.aeracao.horas_aeradas.horas_all;

                const horas = Math.floor(totalSegundos / 3600);
                const minutos = Math.floor((totalSegundos % 3600) / 60);
                const segundos = totalSegundos % 60;

                return `${horas} Hrs ${minutos} min ${segundos} secs`;
            }
            return "";
        },

        dataInicio() {
            if (this.aeracao && this.aeracao.horas_aeradas && this.aeracao.horas_aeradas.data_primeira_aeracao) {
                const data = this.aeracao.horas_aeradas.data_primeira_aeracao.data_inicio;
                return  this.formatarDataPTBR(data);
            }

            return ""
        }
    },
}
</script>
<style scoped>
.text-bolder {
    font-weight: bolder;
}

@media (max-width: 768px) {
    .list-w {
        display: flex;
        flex-direction: column;
    }
}
</style>